"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('receiver', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M9.85786 38.1422C17.6684 45.9527 30.3316 45.9527 38.1421 38.1422L9.85786 9.85791C2.04738 17.6684 2.04738 30.3317 9.85786 38.1422Z",
    fill: props.outFillColor,
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M44 8C44 10.2091 42.2092 12 40 12C39.7154 12 39.4377 11.9703 39.1699 11.9137C38.3984 11.7509 37.7089 11.3658 37.1716 10.8284C36.6343 10.2911 36.2491 9.60161 36.0863 8.83013C36.0298 8.56232 36 8.28463 36 8C36 5.79086 37.7909 4 40 4C42.2092 4 44 5.79086 44 8Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M24 24L37.1716 10.8284M14.1005 14.1005L36.0863 8.83013M33.8995 33.8995L39.1699 11.9137M36.0863 8.83013C36.0298 8.56232 36 8.28463 36 8C36 5.79086 37.7909 4 40 4C42.2092 4 44 5.79086 44 8C44 10.2091 42.2092 12 40 12C39.7154 12 39.4377 11.9703 39.1699 11.9137M36.0863 8.83013C36.2491 9.60161 36.6343 10.2911 37.1716 10.8284M37.1716 10.8284C37.7089 11.3658 38.3984 11.7509 39.1699 11.9137",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});

exports.default = _default;